<template>
<div class="section">
  <div class="section__header">
    <h2>Битва Матриуса</h2>
    <back></back>

    <div class="header-menu">
      <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'Tasks'"
        :class="{active: currentTab === 'Tasks'}"
        v-show="isMaster"
      >
        Задания
      </button>

      <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'TeamList'"
        :class="{active: currentTab === 'TeamList'}"
        v-show="isTeacher"
      >
        Команды
      </button>

      <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'TeamRating'"
        :class="{active: currentTab === 'TeamRating'}"
      >
        Рейтинг
      </button>
    </div>
  </div>

  

  <div class="section__body drawings__content">
    <component
      :is="currentTab"
    ></component>
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        @close-popup="popupIsOpened = false"
        
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import TeamList from './TeamList.vue'
import Tasks from './Tasks.vue'
import TeamRating from './TeamRating.vue'
import { mapGetters } from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'
export default {
  inject: ['http'],
  provide() {
    return {
      user: this.user,
      contest_id: this.contest_id
    }    
  },
  components: { TeamRating, Tasks, TeamList },
  mixins: [ popup_mix ],
  data() {
    return {
      contest_id: 2,
      currentTab: 'TeamList'
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    isMaster() {
      if (this.user.role.id === 1 && this.user.property) {
        return +this.user.property.is_master ? true : false
      }
      return false      
    },
    isTeacher() {
      return this.user.role.id === 1 ? true : false
    },
    isStudent() {
      return this.user.role.id === 2 ? true : false
    }  
  },
  created() {
    if (this.isStudent) {
      this.currentTab = 'TeamRating'
    }
  }
}
</script>
